import ContentPageLayout from 'components/ContentPageLayout'

const Cookies = (): JSX.Element => {
	return <ContentPageLayout contentKey="cookies" />
}

export default Cookies
